import React from 'react';

export default ({handleSortClick, order, sortedBy}) => {
  function createClasses(key) {
    if (sortedBy === key) return `${order ? 'asc' : 'desc'} active`;
    return '';
  }

  return (
    <div className='list-scene__table-header'>
      <div
        className={`list-scene__table-header-element ${createClasses('number')} _width_pc_12`}
        onClick={handleSortClick('number')}
      >
        <div>Brand No</div>
        <div className='list-scene__table-header-element-sort-arrow'></div>
      </div>
      <div
        className={`list-scene__table-header-element ${createClasses('name')} _width_pc_22`}
        onClick={handleSortClick('name')}
      >
        <div>Brand Name</div>
        <div className='list-scene__table-header-element-sort-arrow'></div>
      </div>
      <div
        className={`list-scene__table-header-element ${createClasses('formulaBaseOilNumber')} _width_pc_12`}
        onClick={handleSortClick('formulaBaseOilNumber')}
      >
        <div>Base Oil Number</div>
        <div className='list-scene__table-header-element-sort-arrow'></div>
      </div>
      <div
        className={`list-scene__table-header-element ${createClasses('formulaEngineType')} _width_pc_10`}
        onClick={handleSortClick('formulaEngineType')}
      >
        <div>Engine Oil Type</div>
        <div className='list-scene__table-header-element-sort-arrow'></div>
      </div>
      <div
        className={`list-scene__table-header-element ${createClasses('year')} _width_pc_8`}
        onClick={handleSortClick('year')}
      >
        <div>Year</div>
        <div className='list-scene__table-header-element-sort-arrow'></div>
      </div>
      <div
        className={`list-scene__table-header-element ${createClasses('applicationStatus')} _width_pc_12`}
        onClick={handleSortClick('applicationStatus')}
      >
        <div>Status</div>
        <div className='list-scene__table-header-element-sort-arrow'></div>
      </div>
      <div
        className={`list-scene__table-header-element ${createClasses('isPaid')} _width_pc_12`}
        onClick={handleSortClick('isPaid')}
      >
        <div>Fee status</div>
        <div className='list-scene__table-header-element-sort-arrow'></div>
      </div>
      <div className='list-scene__table-header-element  _width_pc_18' />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/brand/List/TableHeader.jsx